var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTime = function SvgIconTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_time_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4.25C5.537 4.25.5 9.287.5 15.5c0 6.212 5.037 11.25 11.25 11.25C17.962 26.75 23 21.712 23 15.5c0-6.213-5.038-11.25-11.25-11.25Zm0 20C6.925 24.25 3 20.325 3 15.5s3.925-8.75 8.75-8.75 8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9.25h-2.5v6.762l4.738 4.75 1.774-1.774-4.012-4V9.25ZM22.988 4.9v2.7A8.738 8.738 0 0 1 28 15.5c0 3.488-2.05 6.5-5.012 7.9v2.7c4.362-1.55 7.512-5.713 7.512-10.6s-3.15-9.05-7.512-10.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_time_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgIconTime;